import { existsSync } from "node:fs";
import path from "node:path";

export function detectProjectType(cwd = process.cwd()): string {
  if (existsSync(path.join(cwd, "vite.config.ts")) || existsSync(path.join(cwd, "vite.config.js"))) {
    return "vite";
  }

  if (existsSync(path.join(cwd, "artisan"))) {
    return "laravel";
  }

  if (existsSync(path.join(cwd, "package.json"))) {
    return "node-web";
  }

  return "static";
}
